import * as React from "react";
import {useCallback, useState} from "react";
import {Tab, Tabs} from "@mui/material";

export type PageTab = {
    tab: string,
    label: string,
    content: () => JSX.Element,
    disabled?: boolean
}

export type PageTabsProps = {
    tabs: PageTab[],
    currentTab?: string
    onTabChange?: (tab: string) => void
}

export const PageTabs = ({tabs, currentTab, onTabChange}: PageTabsProps) => {
    const [value, setValue] = useState(currentTab ? (tabs.indexOf(tabs.find(t => t.tab === currentTab)!) || 0) : 0);

    const handleChange = useCallback((event: React.SyntheticEvent, newValue: number) => {
        if (onTabChange) {
            onTabChange(tabs[newValue].tab);
        }
        setValue(newValue);
    }, [tabs, onTabChange]);

    return <>
        <Tabs key={'tabs'} value={value} onChange={handleChange} scrollButtons={'auto'} variant={'scrollable'} allowScrollButtonsMobile>
            {tabs.map((tab, i) => {
                return <Tab label={tab.label} key={i} disabled={!!tab.disabled}/>
            })}
        </Tabs>
        {tabs[value]?.content()}
    </>;
}
